// StaticAntd.js
import { App } from "antd";

export let message = null;
export let notification = null;
export let modal = null;

export const StaticAntd = () => {
  const staticFunctions = App.useApp();
  message = staticFunctions.message;
  notification = staticFunctions.notification;
  modal = staticFunctions.modal;

  return null; // Este componente no renderiza nada visualmente
};

export default StaticAntd;
